// https://onyxpayments.atlassian.net/wiki/spaces/PION/pages/35160086/Payment+Statuses

export enum UISearchStatusMappingEnum {
  PAYMENT_IN_PROCESS = <any>'paymentInProcess',
  UNPAID = <any>'unpaid',
  PAID = <any>'paid'
}




// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/ui-search-status-mapping-enum.ts